import { gql } from '@apollo/client';

const GET_CONSENT_TEMPLATE = gql`
  query getConsentTemplateByDataProcessorOrTemplateId($searchTerm: String!) {
    getConsentTemplateByDataProcessorOrTemplateId(searchTerm: $searchTerm) {
      dataProcessor
      descriptionOfService
      nameOfProcessingCompany
      addressOfProcessingCompany
      dataProtectionOfficer
      privacyPolicyURL
      cookiePolicyURL
      iabId
      iabv2Id
      dataRecipientsList
      dataPurposesList
      dataCollectedList
      locationOfProcessing
      thirdCountryTransfer
      retentionPeriodDescription
      technologyUsed
      legalBasisList
      optOutUrl
      defaultCategorySlug
      language
      version
      templateId
      updatedAt
      updatedBy
      createdAt
      createdBy
      cookieMaxAgeSeconds
      usesNonCookieAccess
      deviceStorageDisclosureUrl
      isDeprecated
      deviceStorage {
        disclosures {
          identifier
          type
          name
          maxAgeSeconds
          domain
          description
        }
      }
    }
  }
`;

export default GET_CONSENT_TEMPLATE;

export const SEARCH_CONSENT_TEMPLATES = gql`
  query getConsentTemplateByTerm($searchField: SearchDPSFields!, $searchArray: [String!]!) {
    getConsentTemplateByTerm(searchField: $searchField, searchArray: $searchArray) {
      dataProcessor
      descriptionOfService
      nameOfProcessingCompany
      addressOfProcessingCompany
      dataProtectionOfficer
      privacyPolicyURL
      cookiePolicyURL
      iabId
      iabv2Id
      dataRecipientsList
      dataPurposesList
      dataCollectedList
      locationOfProcessing
      thirdCountryTransfer
      retentionPeriodDescription
      technologyUsed
      legalBasisList
      optOutUrl
      defaultCategorySlug
      language
      version
      templateId
      updatedAt
      updatedBy
      createdAt
      createdBy
      cookieMaxAgeSeconds
      usesNonCookieAccess
      deviceStorageDisclosureUrl
      isDeprecated
      deviceStorage {
        disclosures {
          identifier
          type
          name
          maxAgeSeconds
          domain
          description
        }
      }
    }
  }
`;
